import React, { Component } from 'react';
import LandingPage from '@pages/LandingPage';
import AboutPage from '@pages/AboutPage';
import PortfolioPage from '@pages/PortfolioPage';
import TechnicalPage from '@pages/TechnicalPage';
import ContactPage from '@pages/ContactPage';
import ParallaxBackground from '@components/ParallaxBackground';
import ThemeSwitcher from '@components/ThemeSwitcher';
import Nav from '@components/Nav';
import SectionDots from '@components/SectionDots';
import ScrollProgressBar from '@components/ScrollProgressBar';

const SECTION_SELECTORS = [
  '.landing-page',
  '#about',
  '#experience',
  '#projects',
  '#contact',
];

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { activeSectionIndex: 0 };
  }

  componentDidMount() {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
    this._revealObserver = revealObserver;

    this._sectionMap = new Map();
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = this._sectionMap.get(entry.target);
            if (index !== undefined) this.setState({ activeSectionIndex: index });
          }
        });
      },
      { threshold: 0.5 }
    );
    SECTION_SELECTORS.forEach((selector, index) => {
      const el = document.querySelector(selector);
      if (el) {
        this._sectionMap.set(el, index);
        sectionObserver.observe(el);
      }
    });
    this._sectionObserver = sectionObserver;
  }

  componentWillUnmount() {
    if (this._revealObserver) this._revealObserver.disconnect();
    if (this._sectionObserver) this._sectionObserver.disconnect();
  }

  render() {
    const { activeSectionIndex } = this.state;
    return (
      <div className="dev-landing-page">
        <ThemeSwitcher>
          <ScrollProgressBar />
          <Nav />
          <SectionDots activeIndex={activeSectionIndex} />
          <ParallaxBackground />
          <LandingPage />
          <AboutPage />
          <TechnicalPage />
          <PortfolioPage />
          <ContactPage />
        </ThemeSwitcher>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js